import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// ✅ Enable credentials globally
axios.defaults.withCredentials = true;

const instance = axios.create({
  baseURL: API_URL,
  withCredentials: true, // ✅ Ensures cookies are sent
  validateStatus: function (status) {
    return (status >= 200 && status < 300) || status === 206; // ✅ Fixed parentheses to clarify logic
  }
});

// ✅ Interceptor to handle backend responses
/** 
instance.interceptors.response.use(
  (response) => {
    if (response.data.success) {
      return response.data; // ✅ Return full wrapped response (frontend will check `success`)
    } else {
      return Promise.reject(response.data); // ❌ Handle failed response correctly
    }
  },
  (error) => {
    return Promise.reject(error.response?.data || { success: false, message: "Network error" });
  }
);
*/

export default instance;
